import getStore from '../store/store';
import TodoFolderView from '../store/schema/TodoFolderView';

export default function getSelectedFolderView(): TodoFolderView {
    return getStore().selectedFolderView;
}
